import React from "react";
import StepsTodo from "./components/stepsTodo";
import ListingFollowup from "./components/listingFollowup";
import StillForRent from "./components/stillForRent";
import Rented from "./components/rented";
import CancelScheduledReports from "./components/cancelScheduledReports";
import EndingMgm from "./components/endingMgm";
import EndingManagment from "./components/endingManagment";

const ListingFollowUp = ({ itemId, listId, checkedItems }) => {
  return (
    <div>
      {itemId === 1 && (
        <StepsTodo
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 2 && (
        <ListingFollowup
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 3 && (
        <StillForRent
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 4 && (
        <Rented itemId={itemId} listId={listId} checkedItems={checkedItems} />
      )}
      {itemId === 5 && (
        <CancelScheduledReports
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 6 && (
        <EndingMgm
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 7 && (
        <EndingManagment
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
    </div>
  );
};

export default ListingFollowUp;
